import { createSlice } from "@reduxjs/toolkit";
import {
  fetchFavoriteTeachers,
  addFavoriteTeacher,
  removeFavoriteTeacher,
} from "./operation.js";

const studentFavoritesSlice = createSlice({
  name: "studentFavorites",
  initialState: {
    favorites: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavoriteTeachers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFavoriteTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.favorites = action.payload;
      })
      .addCase(fetchFavoriteTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addFavoriteTeacher.fulfilled, (state, action) => {
        state.favorites.push(action.payload);
      })
      .addCase(removeFavoriteTeacher.fulfilled, (state, action) => {
        state.favorites = state.favorites.filter(
          (t) => t.id !== action.payload
        );
      });
  },
});

export default studentFavoritesSlice.reducer;
